<template>
  <q-dialog v-model="shown">
    <q-card
      :style="{
        'width': $q.screen.gt.xs ? '500px' : '100%',
        'max-width': '500px'
      }"
    >
      <q-card-section>
        <div class="row q-mx-sm q-mb-md">
          <span class="col text-h5">
            {{ title }}
            <q-icon
              v-if="tooltip"
              name="info"
              size="sm"
            >
              <q-tooltip>
                <!-- eslint-disable vue/no-v-html -->
                <div v-html="tooltip" />
                <!-- eslint-enable vue/no-v-html -->
              </q-tooltip>
            </q-icon>
          </span>
          <q-btn
            label="Add Block"
            class="col-auto q-mb-auto"
            outline
            @click="addBlock"
          />
        </div>
        <div>
          <q-list
            v-if="blocks && blocks.length > 0"
          >
            <q-item
              v-for="(block, index) in blocks"
              :key="index"
              v-ripple
              clickable
              :dark="index === currentIndex"
              :style="(index === currentIndex) ? 'background-color: black;' : ''"
            >
              <q-item-section>
                <q-item-label overline>
                  {{ $_.startCase(block.type) }}
                </q-item-label>
                <q-item-label>
                  <!-- eslint-disable vue/no-v-html -->
                  <span v-html="block.type === 'custom-text' ? (block[localizeKey('text')] || block.text) : ''" />
                  <!-- eslint-enable vue/no-v-html -->
                </q-item-label>
              </q-item-section>
              <q-item-section class="col-1">
                <q-btn
                  icon="edit"
                  @click="currentIndex = index"
                />
              </q-item-section>
              <q-item-section class="col-1">
                <q-btn
                  icon="delete"
                  @click="() => removeBlock(index)"
                />
              </q-item-section>
            </q-item>
          </q-list>
        </div>
        <div
          v-if="blocks && currentIndex !== null"
          class="row q-col-gutter-md items-start q-mt-sm"
        >
          <model-form-select
            :field="`config.${blocksKey}[${currentIndex}].type`"
            value-type="String"
            class="col-6"
            label="Block Type"
            map-options
            emit-value
            :options="$mh.asOptions(blockTypes)"
          />
          <model-form-input
            v-if="blocks[currentIndex].type === 'custom-text'"
            :field="`config.${blocksKey}[${currentIndex}].text`"
            value-type="String"
            class="col-6"
            label="Text"
          />
        </div>
        <div
          v-if="blocks && blocks.length > 0"
          class="q-mt-lg"
        >
          <div class="row text-h5 q-mb-sm">
            Preview
          </div>
          <div>
            <span
              v-for="(block, index) in blocks"
              :key="index"
            >
              <!-- eslint-disable vue/no-v-html -->
              <span
                v-if="block.type === 'custom-text'"
                v-html="'<span>' + (block[localizeKey('text')] || block.text) + '</span>'"
              />
              <!-- eslint-enable vue/no-v-html -->
              <span v-else>{{ `{ ${block.type} }` }}</span>
            </span>
          </div>
        </div>
      </q-card-section>
      <q-card-actions class="row justify-end q-ma-sm">
        <q-btn
          label="done"
          color="primary"
          @click="save"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { LocalizedJsonObject } from 'src/models/model'

export default {
  name: 'GenericFormBlocksDialog',
  props: {
    section: {
      type: Object,
      required: true
    },
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: 'Form Blocks'
    },
    tooltip: {
      type: String,
      required: false,
      default: null
    },
    blocksKey: {
      type: String,
      required: true
    },
    formFieldsKey: {
      type: String,
      required: true
    }
  },
  emits: ['update:model-value', 'save'],
  data () {
    return {
      shown: false,
      currentIndex: null
    }
  },
  computed: {
    blocks () {
      return this.section.config[this.blocksKey]
    },
    formFields () {
      return this.section.config[this.formFieldsKey]
    },
    blockTypes () {
      return [
        'custom-text',
        ..._.map(this.formFields, 'label')
      ]
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    hide () {
      this.shown = false
    },
    addBlock () {
      this.blocks.push({
        type: 'custom-text',
        text: ''
      })
      this.currentIndex = this.blocks.length - 1
    },
    removeBlock (index) {
      if (this.currentIndex > index) {
        this.currentIndex -= 1
      } else if (this.currentIndex === index) {
        this.currentIndex = null
      }

      this.blocks.splice(index, 1)
    },
    save () {
      this.$emit('save', this.blocks)
      this.shown = false
    },
    // Only necessary for the translatable JSON keys because they aren't automatically localized
    // in Admin app outside of previews.
    localizeKey (key) {
      const localizedKey = LocalizedJsonObject.localizeKey(key, this.section.language)[0]
      return localizedKey
    }
  }
}
</script>
